import { Link, useNavigate } from "react-router-dom";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from "@/components/ui/breadcrumb";
import { PageHeader } from "@/components/ui/page-header";

import { ProvisionNewFirmForm } from "./ProvisionNewFirmForm";

export function LawFirmsCreate() {
  const navigate = useNavigate();

  return (
    <div className="h-full w-full overflow-y-auto bg-surface">
      <div className="mx-auto flex w-full max-w-280 flex-col gap-6 px-12 pt-10 pb-24 max-md:px-4">
        <div className="flex flex-col gap-3">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>Admin</BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/admin/law-firms">Law Firms</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Provision New Firm</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
          <PageHeader
            title="Provision New Law Firm"
            description="Set up a new firm account with subscription details and initial configuration."
          />
        </div>
        <ProvisionNewFirmForm
          variant="page"
          onCancel={() => navigate("/admin/law-firms")}
          onCreated={(lawFirmUid) => navigate(`/admin/law-firms/${lawFirmUid}`)}
        />
      </div>
    </div>
  );
}
